$(document).on("ready", function () {

  // Brochures
  $(".broSlider").slick({
      dots: false,
      padding:0,
      infinite: true,
      centerMode: false,
      slidesToShow: 5,
      arrows:false,
      autoplay:true,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:true,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:true,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

  // Four Cols Scroll
  $(".colSlider").slick({
      dots: false,
      padding:0,
      infinite: true,
      centerMode: false,
      slidesToShow: 4,
      arrows:false,
      autoplay:true,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });
  
  // Category Blocks

  // Common settings
const slickOptions = {
    dots: false,
    infinite: true,
    centerMode: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 4500,
    nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span>',
    prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span>',
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1450,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                arrows: false
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                arrows: false
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                arrows: false
            }
        },
        {
            breakpoint: 767,
            settings: "unslick"
        }
    ]
};

// All sliders except Clearance page
$(".catBlocks")
    .not(".forBgtemplate--28875489214841__levitate_cat_blocks_biigUp .catBlocks")
    .slick({
        ...slickOptions,
        slidesToShow: 5
    });

// Clearance page slider
$(".forBgtemplate--28875489214841__levitate_cat_blocks_biigUp .catBlocks").slick({
    ...slickOptions,
    slidesToShow: 4
});
  // Home Slider Blocks

  $(".imageSlider").slick({
      dots: false,
      padding:0,
      infinite: true,
      centerMode: false,
      slidesToShow: 2,
      arrows:false,
      autoplay:true,
      autoplaySpeed:4500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

  $(".imageSlider2").slick({
      dots: false,
      padding:0,
      infinite: true,
      centerMode: false,
      slidesToShow: 2,
      arrows:false,
      rtl: true,
      autoplay:true,
      autoplaySpeed:4500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

  // Why Choose Blocks

  $(".catChoose").slick({
      dots: true,
      padding:0,
      infinite: true,
      centerMode: true,
      slidesToShow: 3,
      arrows:false,
      autoplay:true,
      autoplaySpeed:4500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:true,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:true,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:true,
            arrows:false
          }
        }
      ],
  });

  // Testimonial Home

  $(".testimonialSlider").slick({
    dots: true,
    padding:0,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

// Logo Scroll Bussiness

  $(".scrollCols").slick({
    dots: false,
    padding:0,
    infinite: true,
    centerMode: true,
    slidesToShow: 6,
    arrows:false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          arrows:false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          arrows:false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          arrows:false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      }
    ]
  });
  
  // Product Slider 

  $(".productSliderHome").slick({
    dots: false,
    padding:0,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    arrows:true,
    autoplay:false,
    autoplaySpeed:2500,
    nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span>',
    prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></span>',
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  // Instagram
  
  $(".instagramSlider").slick({
    dots: false,
    padding:0,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    arrows:false,
    autoplaySpeed:3500,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 12000,
    pauseOnHover: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  /* Team Slider About Page */
  $(".teamSlider").slick({
    dots: true,
    padding:0,
    infinite: true,
    centerMode: true,
    slidesToShow: 4,
    arrows:false,
    autoplay:false,
    autoplaySpeed:2500,
    nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
    prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          arrows:false
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });
/* Clearence Page */
// First
$(".ai-clearance-scroller__track-aejzkem1bt25mwnjtuaigenblocka331384cu4wij").slick({
      dots: false,
      padding:0,
      infinite: false,
      centerMode: false,
      slidesToShow: 4,
      arrows:false,
      autoplay:true,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

  // 2nd
$(".ai-clearance-scroller__track-azvlqwm92bvpkumvjaaigenblocka331384plapep").slick({
      dots: false,
      padding:0,
      infinite: false,
      centerMode: false,
      slidesToShow: 4,
      arrows:false,
      autoplay:true,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

  $(".ai-clearance-scroller__track-ayxphynarrng3dmvidaigenblocka331384t6cg3k").slick({
      dots: false,
      padding:0,
      infinite: false,
      centerMode: false,
      slidesToShow: 4,
      arrows:false,
      autoplay:true,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

  $(".ai-clearance-scroller__track-ac1z2dnjpuxk2qtlosaigenblocka331384glxnc9").slick({
      dots: false,
      padding:0,
      infinite: false,
      centerMode: false,
      slidesToShow: 4,
      arrows:false,
      autoplay:true,
      autoplaySpeed:2500,
      nextArrow: '<span class="next arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      prevArrow: '<span class="prev arrows"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"></path></svg></span>',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            arrows:false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            arrows:false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
         {
          breakpoint: 567,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots:false,
            arrows:false
          }
        }
      ],
  });

/* Faqs */
  let question = document.querySelectorAll(".question");
    question.forEach(question => {
      question.addEventListener("click", event => {
        const active = document.querySelector(".question.active");
        if(active && active !== question ) {
          active.classList.toggle("active");
          active.nextElementSibling.style.maxHeight = 0;
        }
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if(question.classList.contains("active")){
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          answer.style.maxHeight = 0;
        }
      })
    })

  let myContainer = document.querySelectorAll(".myContainer");
  
  myContainer.forEach(myContainer => {
      myContainer.addEventListener("click", event => {
      const active = document.querySelector(".myContainer.active");
      if(active && active !== myContainer ) {
          active.classList.toggle("active");
      }
      myContainer.classList.toggle("active");
      const answer = myContainer.nextElementSibling;
      if(myContainer.classList.contains("active")){
      } else {
      }
      })
  })
  /* End Here */
});



/* Menu Js */
jQuery(document).ready(function ($) {

    var body = "body";
    var active = "active";
    var overlay = "#overlay";

    var tab1 = "#HeaderMenu-showers-steam";
    var tab1Menu = "#tab1";

    var tab2 = "#HeaderMenu-saunas";
    var tab2Menu = "#tab2";

    var tab3 = "#HeaderMenu-steam-room-generators";
    var tab3Menu = "#tab3";

    var tab4 = "#HeaderMenu-body-dryers";
    var tab4Menu = "#tab4";

    var tab5 = "#HeaderMenu-ice-baths";
    var tab5Menu = "#tab5";

    var tab6 = "#HeaderMenu-essentials";
    var tab6Menu = "#tab6";

    var tab7 = "#HeaderMenu-red-light";
    var tab7Menu = "#tab7";

    var tab8 = "#HeaderMenu-accessories-spares";
    var tab8Menu = "#tab8";

    var tab9 = "#HeaderMenu-brand-partners";
    var tab9Menu = "#tab9";
    

    $(tab1).click(function () {
        $(body).toggleClass(active);
        $(tab1Menu).toggleClass(active);
        $(tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab2).click(function () {
        $(body).toggleClass(active);
        $(tab2Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab3).click(function () {
        $(body).toggleClass(active);
        $(tab3Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab4).click(function () {
        $(body).toggleClass(active);
        $(tab4Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab5).click(function () {
        $(body).toggleClass(active);
        $(tab5Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab6).click(function () {
        $(body).toggleClass(active);
        $(tab6Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab7).click(function () {
        $(body).toggleClass(active);
        $(tab7Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab8).click(function () {
        $(body).toggleClass(active);
        $(tab8Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab9Menu).removeClass(active);
    });

    $(tab9).click(function () {
        $(body).toggleClass(active);
        $(tab9Menu).toggleClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu).removeClass(active);
    });  
    
    $(overlay).click(function () {
        $(body).removeClass(active);
        $(tab1Menu + ', ' + tab2Menu + ', ' + tab3Menu + ', ' + tab4Menu + ', ' + tab5Menu + ', ' + tab6Menu + ', ' + tab7Menu + ', ' + tab8Menu + ', ' + tab9Menu).removeClass(active);
    });

});


/* Faq Page */

jQuery(document).ready(function ($) {
  // Show the first tab and hide the rest
  $('#tabs-nav li:first-child').addClass('active');
  $('.tab-content').hide();
  $('.tab-content:first').show();

  // Click function
  $('#tabs-nav li').click(function(){
    $('#tabs-nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });
});



document.addEventListener("DOMContentLoaded", function () {

  const stickyBar = document.getElementById("stickyATC");
  const originalBtn = document.querySelector('button[name="add"]');
  const stickyBtn = document.getElementById("stickyBtn");
  const stickyPrice = document.getElementById("stickyPrice");

  if (!stickyBar || !originalBtn || !stickyBtn) return;

  // SHOW/HIDE STICKY ATC
  const observer = new IntersectionObserver(
    ([entry]) => {
      stickyBar.style.display = entry.isIntersecting ? "none" : "block";
    },
    {
      threshold: 0
    }
  );

  observer.observe(originalBtn);

  // STICKY BUTTON CLICK
  stickyBtn.addEventListener("click", function (e) {
    e.preventDefault();

    if (originalBtn.disabled) {
      alert("Please select options first");
      return;
    }

    originalBtn.click();
  });

  // UPDATE PRICE WHEN VARIANT CHANGES
  document.addEventListener("change", function (e) {

    if (!e.target.closest('form[action*="/cart/add"]')) return;

    setTimeout(() => {
      const priceEl =
        document.querySelector('.price-item--sale') ||
        document.querySelector('.price-item--regular') ||
        document.querySelector('.price');

      if (priceEl && stickyPrice) {
        stickyPrice.textContent = priceEl.textContent.trim();
      }
    }, 100);

  });

});


/* INIT
function getWishlist() {
  return JSON.parse(localStorage.getItem('wishlist')) || [];
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  updateWishlistCount();
}

// ADD / REMOVE
function toggleWishlist(handle) {
  let wishlist = getWishlist();

  if (wishlist.includes(handle)) {
    wishlist = wishlist.filter(item => item !== handle);
  } else {
    wishlist.push(handle);
  }

  saveWishlist(wishlist);
  updateButtons();
}

// BUTTON CLICK
document.addEventListener('click', function(e) {
  if (e.target.closest('.wishlist-btn')) {
    let btn = e.target.closest('.wishlist-btn');
    let handle = btn.getAttribute('data-product-handle');
    toggleWishlist(handle);
  }
});

// UPDATE BUTTON UI
function updateButtons() {
  let wishlist = getWishlist();

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    let handle = btn.getAttribute('data-product-handle');
    let path = btn.querySelector('svg path');

    if (!path) return;

    if (wishlist.includes(handle)) {
      // ❤️ FILLED
      path.setAttribute('fill', 'red');
      path.setAttribute('stroke', 'red');
      btn.classList.add('active');
    } else {
      // ♡ OUTLINE
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', '#fff');
      btn.classList.remove('active');
    }
  });
}

// HEADER COUNT
function updateWishlistCount() {
  let count = getWishlist().length;
  let el = document.querySelector('.wishlist-count');
  if (el) el.innerText = count;
}

// INIT LOAD
document.addEventListener('DOMContentLoaded', function() {
  updateButtons();
  updateWishlistCount();
});
*/

/* Keep it checked */
function selectEconomyOnce() {
  const economy = document.querySelector('input[value="ECONOMY"]');

  if (!economy) return;

  // check if anything already selected
  const alreadySelected = document.querySelector('input[type="radio"]:checked');
  if (alreadySelected) return;

  // simulate real click (IMPORTANT)
  economy.click();

  // add your custom attribute if needed
  economy.setAttribute('previous-value', 'checked');
}

// try few times then stop
let tries = 0;
const interval = setInterval(() => {
  selectEconomyOnce();
  tries++;
  if (tries > 10) clearInterval(interval);
}, 300);


/* Build page acc */


$(document).ready(function () {

    function toggleAccordions() {
        let selected = $('input[name="buttons-1"]:checked').val();

        // hide all
        $('.economyAcc, .premiumAcc, .platinumAcc').hide();

        // show based on value
        if (selected === 'ECONOMY') {
            $('.economyAcc').show();
        } else if (selected === 'PREMIUM') {
            $('.premiumAcc').show();
        } else if (selected === 'PLATINUM') {
            $('.platinumAcc').show();
        }
    }

    // 👉 Handle radio change (delegated)
    $(document).on('change', 'input[name="buttons-1"]', function () {
        toggleAccordions();
    });

    // 👉 Handle click (for builders that don’t trigger change)
    $(document).on('click', 'input[name="buttons-1"], label[for^="buttons-1"]', function () {
        setTimeout(function () {
            toggleAccordions();
        }, 100);
    });

    // 👉 Run on page load (important for default selection)
    setTimeout(function () {
        toggleAccordions();
    }, 500);

});

/*
$(document).on('mousemove', '.product-media, .product-media-container', function (e) {

    let $container = $(this);
    let $img = $container.find('img');

    if (!$img.length) return;

    let offset = $container.offset();
    let x = e.pageX - offset.left;
    let y = e.pageY - offset.top;

    let width = $container.outerWidth();
    let height = $container.outerHeight();

    let xPercent = (x / width) * 100;
    let yPercent = (y / height) * 100;

    $img.css({
        'transform-origin': xPercent + '% ' + yPercent + '%',
        'transform': 'scale(1.2)' // 🔥 adjust zoom here
    });

});

// 👉 Reset on leave
$(document).on('mouseleave', '.product-media, .product-media-container', function () {
    $(this).find('img').css({
        'transform': 'scale(1)',
        'transform-origin': 'center center'
    });
});
*/


jQuery(function($){

    const header = document.querySelector('#header-component');

    if (!header) return;

    function checkState() {
        $('.levitateMenu').toggleClass(
            'maginAdjust',
            header.getAttribute('data-sticky-state') === 'active'
        );
    }

    checkState(); // initial check

    new MutationObserver(checkState).observe(header, {
        attributes: true,
        attributeFilter: ['data-sticky-state']
    });

});

/* Shopify product page swatch title print */

jQuery(function ($) {
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 50) {
            $('.header-section').addClass('scrolled');
        } else {
            $('.header-section').removeClass('scrolled');
        }
    });
});

/* Share Button */


document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".product-share-btn");
  if (!btn) return;

  const title =
    document.querySelector(".product__title h1")?.textContent.trim() ||
    document.title;

  const url = window.location.href;

  console.log("navigator.share:", navigator.share);
  console.log("navigator.clipboard:", navigator.clipboard);
  console.log("URL:", url);

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      console.log("Shared");
    } catch (err) {
      console.error(err);
    }
  } else {
    try {
      await navigator.clipboard.writeText(url);
      alert("Copied!");
    } catch (err) {
      console.error("Clipboard Error:", err);
      prompt("Copy this:", url);
    }
  }
});

/* =========================
   WISHLIST
========================= */

// =========================
// HELPERS
// =========================
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  } catch (error) {
    return [];
  }
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  updateWishlistCount();
}


// =========================
// GET CURRENT VARIANT ID
// =========================
function getSelectedVariantId(btn) {

  // 1. Check variant ID from URL
  const urlVariant = new URLSearchParams(window.location.search).get('variant');

  if (urlVariant) {
    return Number(urlVariant);
  }


  // 2. Horizon / Levitate selected variant radio button
  const checked = document.querySelector(
    '.variant-option input[type="radio"][data-variant-id]:checked'
  );

  if (checked && checked.dataset.variantId) {
    return Number(checked.dataset.variantId);
  }


  // 3. Any selected input with a variant ID
  const anyChecked = document.querySelector(
    'input[data-variant-id]:checked'
  );

  if (anyChecked && anyChecked.dataset.variantId) {
    return Number(anyChecked.dataset.variantId);
  }


  // 4. Product JSON fallback
  if (btn && btn.dataset.productJson) {
    try {
      const product = JSON.parse(btn.dataset.productJson);

      // Default / selected variant
      if (product.selected_or_first_available_variant) {
        return Number(product.selected_or_first_available_variant.id);
      }

      // First variant fallback
      if (product.variants && product.variants.length > 0) {
        return Number(product.variants[0].id);
      }

    } catch (error) {
      console.error('Wishlist: Unable to read product JSON', error);
    }
  }


  // No variant found
  return null;
}


// =========================
// SAFE WISHLIST STORAGE
// =========================
function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  } catch (error) {
    return [];
  }
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}


// =========================
// GET SELECTED VARIANT ID
// =========================
function getSelectedVariantId(btn) {

  // Variant ID directly on button
  if (btn.dataset.variantId) {
    return btn.dataset.variantId;
  }

  // Find the product/form around this button first
  const productContainer =
    btn.closest('product-info, .product, .product-card, .card-wrapper, form') ||
    document;

  // Checked radio variant
  const checkedRadio = productContainer.querySelector(
    '.variant-option input[type="radio"]:checked, input[data-variant-id]:checked'
  );

  if (checkedRadio && checkedRadio.dataset.variantId) {
    return checkedRadio.dataset.variantId;
  }

  // Variant ID from URL
  const urlVariant = new URLSearchParams(window.location.search).get('variant');
  if (urlVariant) {
    return urlVariant;
  }

  // Variant selector / hidden variant input
  const variantInput = productContainer.querySelector(
    'input[name="id"], select[name="id"]'
  );

  if (variantInput && variantInput.value) {
    return variantInput.value;
  }

  return null;
}


// =========================
// TOGGLE WISHLIST
// =========================
function toggleWishlist(btn) {

  const handle = btn.dataset.productHandle;
  const variantId = getSelectedVariantId(btn);

  if (!handle || !variantId) {
    console.error('Wishlist: Product handle or variant ID not found');
    return;
  }

  let wishlist = getWishlist();

  const index = wishlist.findIndex(function (item) {
    return (
      String(item.handle) === String(handle) &&
      String(item.variantId) === String(variantId)
    );
  });

  if (index > -1) {
    wishlist.splice(index, 1);
  } else {
    wishlist.push({
      handle: handle,
      variantId: String(variantId)
    });
  }

  saveWishlist(wishlist);

  // Update everything immediately
  refreshWishlistUI();
}


// =========================
// UPDATE PRODUCT HEARTS
// =========================
function updateButtons() {

  const wishlist = getWishlist();

  document.querySelectorAll('.wishlist-btn').forEach(function (btn) {

    const handle = btn.dataset.productHandle;
    const variantId = getSelectedVariantId(btn);

    if (!handle || !variantId) return;

    const exists = wishlist.some(function (item) {
      return (
        String(item.handle) === String(handle) &&
        String(item.variantId) === String(variantId)
      );
    });

    const path = btn.querySelector('svg path');

    if (exists) {
      btn.classList.add('active');

      if (path) {
        path.setAttribute('fill', 'red');
        path.setAttribute('stroke', 'red');
      }
    } else {
      btn.classList.remove('active');

      if (path) {
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', '#fff');
      }
    }
  });
}


// =========================
// UPDATE HEADER WISHLIST ICON
// =========================
function updateWishlistCount() {

  const count = getWishlist().length;

  // Update count
  document.querySelectorAll('.wishlist-count').forEach(function (el) {
    el.textContent = count;
  });

  // Update header icon
  document.querySelectorAll('.wishIcon').forEach(function (icon) {

    // Force class based on current localStorage
    icon.classList.toggle('has-wishlist', count > 0);

    // Also update SVG directly as a backup
    const path = icon.querySelector('svg path');

    if (path) {
      if (count > 0) {
        path.style.setProperty('fill', 'red', 'important');
        path.style.setProperty('stroke', 'red', 'important');
      } else {
        path.style.setProperty('fill', 'none', 'important');
        path.style.setProperty('stroke', '#000', 'important');
      }
    }
  });
}


// =========================
// REFRESH COMPLETE UI
// =========================
function refreshWishlistUI() {
  updateButtons();
  updateWishlistCount();
}


// =========================
// WISHLIST BUTTON CLICK
// =========================
document.addEventListener('click', function (e) {

  const btn = e.target.closest('.wishlist-btn');

  if (!btn) return;

  e.preventDefault();
  toggleWishlist(btn);
});


// =========================
// PACKAGE FEATURES
// =========================
function updatePackageFeatures() {

  const selected = document.querySelector(
    '.variant-option input[type="radio"]:checked'
  );

  if (!selected) return;

  const variantId = selected.dataset.variantId;

  if (!variantId) return;

  document
    .querySelectorAll('#package-features .package-feature')
    .forEach(function (el) {

      el.style.display =
        String(el.dataset.variantId) === String(variantId)
          ? 'block'
          : 'none';
    });
}


// =========================
// INITIAL LOAD
// =========================
document.addEventListener('DOMContentLoaded', function () {

  refreshWishlistUI();
  updatePackageFeatures();

  // Run again after Shopify/theme scripts finish
  setTimeout(refreshWishlistUI, 300);
  setTimeout(refreshWishlistUI, 1000);
});


// =========================
// VARIANT CHANGE
// =========================
document.addEventListener('change', function (e) {

  if (
    e.target.matches('input[data-variant-id]') ||
    e.target.matches('.variant-option input[type="radio"]')
  ) {
    setTimeout(function () {
      refreshWishlistUI();
      updatePackageFeatures();
    }, 50);
  }
});


// =========================
// SHOPIFY DYNAMIC SECTION / HEADER UPDATE
// =========================
// If Shopify replaces the header in the DOM,
// reapply the wishlist UI automatically.
const wishlistObserver = new MutationObserver(function () {
  clearTimeout(window.wishlistRefreshTimer);

  window.wishlistRefreshTimer = setTimeout(function () {
    updateWishlistCount();
  }, 100);
});

wishlistObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// =========================
// OTHER TAB / STORAGE UPDATE
// =========================
window.addEventListener('storage', function (e) {
  if (e.key === 'wishlist') {
    refreshWishlistUI();
  }
});




// popup for browserpage

$(document).ready(function () {

  var $modal = $('#brochureModal');
  var $iframeWrapper = $modal.find('.brochureIframeWrapper');

  // OPEN MODAL
  $(document).on('click', '.brochureDownloadBtn', function (e) {

    e.preventDefault();

    var iframeCode = $(this).attr('data-iframe');

    if (!iframeCode) {
      console.log('Iframe code not found');
      return;
    }

    // Decode escaped iframe HTML
    iframeCode = $('<textarea>')
      .html(iframeCode)
      .text();

    // Insert iframe
    $iframeWrapper.html(iframeCode);

    // Open modal
    $modal.addClass('is-open');
    $modal.attr('aria-hidden', 'false');

    // Prevent background page scrolling
    $('body').addClass('brochure-modal-open');

    // Always start modal at top
    $iframeWrapper.scrollTop(0);
    $modal.find('.brochureModalContent').scrollTop(0);

  });


  // CLOSE MODAL
  function closeBrochureModal() {

    $modal.removeClass('is-open');
    $modal.attr('aria-hidden', 'true');

    // Remove iframe completely
    $iframeWrapper.empty();

    // Restore page scrolling
    $('body').removeClass('brochure-modal-open');
  }


  // CLOSE BUTTON
  $(document).on('click', '.brochureModalClose', function (e) {
    e.preventDefault();
    closeBrochureModal();
  });


  // CLICK OVERLAY
  $(document).on('click', '.brochureModalOverlay', function () {
    closeBrochureModal();
  });


  // ESC KEY
  $(document).on('keydown', function (e) {

    if (
      (e.key === 'Escape' || e.keyCode === 27) &&
      $modal.hasClass('is-open')
    ) {
      closeBrochureModal();
    }

  });

});